import { MainButton, Input, Select, Option } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import styles from './CalculatorForm.module.scss'

const CalculatorForm = ({ form, handleSetFormPureValue, handleSetFormValue }) => (
  <div className={styles.CalculatorForm}>
    <div className={styles.FirstRow}>
      <div className={styles.InputGroup}>
        <Input
          label="Amount"
          name="investmentAmount"
          value={form.investmentAmountView}
          onChange={handleSetFormValue}
          iconBefore="$"
        />
      </div>

      <div className={styles.InputGroup}>
        <Input
          label="Target return"
          name="targetReturn"
          value={form.targetReturnView}
          onChange={handleSetFormValue}
          iconAfter="%"
        />
      </div>

      <div className={styles.InputGroup}>
        <Input
          label="Term"
          name="term"
          value={form.termView}
          onChange={handleSetFormValue}
          iconAfter={<small>years</small>}
        />
      </div>

      <div className={`${styles.InputGroup} ${styles.SwitcherInput}`}>
        <Input
          label="Annual fees"
          name="fees"
          value={form.feesView}
          onChange={handleSetFormValue}
          iconAfter={
            <>
              <MainButton
                size="sm"
                shape="squared"
                className={form.feesSwitcher === '$' ? styles.Active : ''}
                onClick={() => handleSetFormPureValue('feesSwitcher', '$')}
              >
                $
              </MainButton>
              <MainButton
                size="sm"
                shape="squared"
                className={form.feesSwitcher === '%' ? styles.Active : ''}
                onClick={() => handleSetFormPureValue('feesSwitcher', '%')}
              >
                %
              </MainButton>
            </>
          }
        />
      </div>
    </div>

    <div className={styles.SecondRow}>
      <div className={styles.InputGroup}>
        <Input
          label="Additional contributions"
          type="text"
          name="contributions"
          value={form.contributionsView}
          onChange={handleSetFormValue}
          iconBefore="$"
        />
      </div>
      <div className={styles.InputGroup}>
        <Select
          label="Frequency"
          name="frequency"
          selectedValue={form.frequency}
          handleOnChange={value => handleSetFormPureValue('frequency', value)}
        >
          <Option value="Weekly">Weekly</Option>
          <Option value="Fortnightly">Fortnightly</Option>
          <Option value="Monthly">Monthly</Option>
          <Option value="Annually">Annually</Option>
        </Select>
      </div>
    </div>
  </div>
)

CalculatorForm.propTypes = {
  form: PropTypes.shape({
    investmentAmount: PropTypes.number,
    investmentAmountView: PropTypes.string,
    targetReturn: PropTypes.number,
    targetReturnView: PropTypes.string,
    term: PropTypes.number,
    termView: PropTypes.string,
    fees: PropTypes.number,
    feesView: PropTypes.string,
    feesSwitcher: PropTypes.string,
    contributions: PropTypes.number,
    contributionsView: PropTypes.string,
    frequency: PropTypes.string
  }),
  handleSetFormPureValue: PropTypes.func,
  handleSetFormValue: PropTypes.func
}

CalculatorForm.defaultProps = {
  form: {
    investmentAmount: 1000,
    investmentAmountView: '1,000',
    targetReturn: 8,
    targetReturnView: '8',
    term: 5,
    termView: '5',
    fees: 1,
    feesView: '1',
    feesSwitcher: '%',
    contributions: 100,
    contributionsView: '100',
    frequency: 'Monthly'
  },
  handleSetFormPureValue: () => {},
  handleSetFormValue: () => {}
}

export default CalculatorForm
